import * as React from "react";
import { Navigate, useLocation } from "react-router-dom";

import useAuthContext from "../hooks/useAuthContext";
import { isOtpRequired } from "./otpSessionStore";

export function RequireAuth({ children }: { children: JSX.Element }) {
    const { user } = useAuthContext();
    const location = useLocation();

    React.useEffect(() => {
        if (!user) {
            return;
        }

        localStorage.setItem("from", `${location.pathname}${location.search}`);
    }, [location.pathname, location.search, user]);

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    if (isOtpRequired(user.uid) && location.pathname !== "/otp-verification") {
        return <Navigate to="/otp-verification" replace />;
    }

    return children;
}
